/**
 * Who put a link here, said once for every surface (F16 of
 * docs/plans/qa-run-1-review.md, Q7 of docs/plans/qa-fixes-1.md).
 *
 * `createdBy` is app.link.created_by, free text per its column note: user,
 * template, onboarding, or suggestion with its id. A link setup built says
 * "Made when you set up". An author this does not know says nothing: a line
 * that claimed "a suggestion you accepted" for any value it could not place
 * was false provenance, and silence is not.
 */
import { t } from './i18n/t';

/** The authors a person can be told about. */
export type LinkAuthor = 'user' | 'template' | 'setup' | 'suggestion';

/**
 * The author a stored `created_by` names, or null for one nothing knows.
 * `agent` is what Create wrote for a setup's links before it wrote
 * `onboarding`; Create was its only writer, so it reads as setup.
 */
export const linkAuthorOf = (createdBy: string): LinkAuthor | null => {
  if (createdBy === 'user') return 'user';
  if (createdBy === 'template') return 'template';
  if (createdBy === 'onboarding' || createdBy === 'agent') return 'setup';
  if (createdBy.startsWith('suggestion')) return 'suggestion';
  return null;
};

/** The line a link's card says about who made it, or null to say nothing. */
export const linkAuthorLine = (createdBy: string): string | null => {
  const author = linkAuthorOf(createdBy);
  if (author === null) return null;
  if (author === 'setup') return t('link.made_at_setup');
  if (author === 'user') return t('link.added_by', { person: t('link.by_user') });
  if (author === 'template') return t('link.added_by', { person: t('link.by_template') });
  return t('link.added_by', { person: t('link.by_suggestion') });
};
